import { createAction } from '@reduxjs/toolkit';
import noop from 'lodash/noop';
export const createPromiseAction = (type) => createAction(type, (payload, resolve = noop, reject = noop) => ({
    payload,
    meta: { resolve, reject },
}));
export function bindRtkActionToPromise(dispatch, actionCreator) {
    return (payload) => {
        return new Promise((resolve, reject) => dispatch(actionCreator(payload, resolve, reject)));
    };
}
